import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getLocationBillToEntity, isLocationBillToVisible } from '../../utils/LocationUtils';

interface LocationBillToDisplayProps {
	location: any;
	className?: string;
	currentUser?: any;
	companyConfig?: any;
}

const LocationBillToDisplay: FC<LocationBillToDisplayProps> = ({
	location,
	className,
	currentUser,
	companyConfig,
}) => {
	const billToEntity = getLocationBillToEntity(location);

	if (!billToEntity || !isLocationBillToVisible(currentUser, companyConfig, location)) {
		return null;
	}

	return <div className={className}>Bill to: {billToEntity}</div>;
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
});

export default connect(mapStateToProps)(LocationBillToDisplay);
